export const EVOLUTION_EVENTS = {
    APPLICATION_READY: 'EVO:APPLICATION_READY',
    GAME_LIFECYCLE: 'EVO:GAME_LIFECYCLE',
    SESSION_INVALID: 'EVO:SESSION_INVALID',
    SHOW_DEPOSIT: 'EVO:SHOW_DEPOSIT',
    SHOW_RESPONSIBLE_GAMING: 'EVO:SHOW_RESPONSIBLE_GAMING'
};

export const EVOLUTION_COMMANDS = {
    EVENT_SUBSCRIBE: 'EVO:EVENT_SUBSCRIBE',
    EXIT_FULLSCREEN: 'EVO:EXIT_FULLSCREEN'
};

export const EVOLUTION_APP_TYPE = {
    GAME: 'game'
};
